import {
  FETCH_ACCOUNT_TYPE_MAPPING_REQUEST,
  FETCH_ACCOUNT_TYPE_MAPPING_SUCCESS,
  FETCH_ACCOUNT_TYPE_MAPPING_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const fetchAccountTypeMappingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACCOUNT_TYPE_MAPPING_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_ACCOUNT_TYPE_MAPPING_SUCCESS:
      return {
        ...state,
        loading: false,
        data: Array.isArray(action.payload?.data) ? action.payload.data : [],
      };
    case FETCH_ACCOUNT_TYPE_MAPPING_FAILURE:
      return { ...state, loading: false, error: action.payload, data: [] };
    default:
      return state;
  }
};

export default fetchAccountTypeMappingReducer;
